import React from "react"
import styled from "styled-components"

const MAndVSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f9f3ec;
  padding: 78px 136px 56px;
  background-color: #f9f3ec;

  h2 {
    font-family: "Tinos", serif;
    font-size: 22px;
    line-height: 25px;
    font-style: italic;
    font-weight: 700;
    color: #989085;
    margin-bottom: 32px;
  }

  p {
    font-family: "Amasis", serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 31px;
    letter-spacing: 0em;
    text-align: center;
    max-width: 1100px;
    color: #3e3120;
  }

  p.mission {
    margin-bottom: 4px;
  }

  @media only screen and (max-width: 1100px) {
    padding: 78px 120px 56px;
  }
  @media only screen and (max-width: 1000px) {
    padding: 78px 108px 56px;
    h2 {
      font-size: 20px;
      line-height: auto;
    }
    p {
      font-size: 18px;
      line-height: auto;
    }
  }
  @media only screen and (max-width: 900px) {
    padding: 78px 96px 56px;
  }
  @media only screen and (max-width: 800px) {
    padding: 78px 80px 56px;
    h2 {
      font-size: 18px;
      line-height: auto;
    }
    p {
      font-size: 16px;
      line-height: auto;
    }
  }
  @media only screen and (max-width: 700px) {
    padding: 78px 64px 56px;
  }
  @media only screen and (max-width: 600px) {
    padding: 78px 48px 56px;
    h2 {
      font-size: 16px;
      line-height: auto;
    }
    p {
      font-size: 14px;
      line-height: auto;
    }
  }
  @media only screen and (max-width: 500px) {
    padding: 78px 36px 56px;
    h2 {
      font-size: 14px;
      line-height: auto;
    }
    p {
      font-size: 12px;
      line-height: auto;
    }
  }
  @media only screen and (max-width: 400px) {
    padding: 78px 24px 56px;
  }
`

const MAndV: React.FC<{ mission: string; vision: string }> = function ({
  mission,
  vision,
}) {
  return (
    <MAndVSection>
      <h2>Our Mission and Vision</h2>
      <p className="mission">{mission}</p>
      <p className="vision">{vision}</p>
    </MAndVSection>
  )
}

export default MAndV
